import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/(app)/_auth/settings/communication/reception",
)({
  loader: () => ({
    crumb: "alfred.settings.nav.communicationReception.label",
  }),
})
